// 定义一个接口来描述可能被注入到window对象中的自定义Android接口
// Interface to describe the custom Android interface that might be injected into the window object
interface AndroidInterface {
  [key: string]: (data: string, param1?: string, param2?: string) => string;
}

// 使用声明合并来扩展现有Window接口，增加自定义Android属性
// Declaration merge to extend the existing Window interface with the custom Android property
declare global {
  interface Window {
    android?: AndroidInterface;
  }
}

// 定义一个接口确保数据参数具有强类型
// Interface for the data parameter to ensure strong typing
interface H5EventData {
  event: string;
  callback: string | ((result: any) => void);
  [key: string]: any; // 其他字段可以是任意类型
}

// 用于生成唯一回调函数名称的计数器
// Counter for generating unique callback function names
let _H5Event_Num = 1;

// 主函数用于处理H5事件
// The main function to handle H5 events
export const _H5Event = (data: H5EventData) => {
  if (!data || !data.event) return;

  if (process.env.REACT_APP_IS_FROM_APP === "false") {
    const callback = data.callback;
    if (callback && typeof callback === 'function') {
      callback(
        JSON.stringify({
          token:
            "",
          lang: "zh",
        })
      );
    }
    return;
  }
  if (window.android && typeof window.android[data.event] === "function") {
    // Android特定处理方式
    // Android specific handling
    const result = window.android[data.event](JSON.stringify(data));
    handleCallback(data.callback, result);
  } else {
    // iOS特定处理方式
    // iOS specific handling
    handleIOSCallback(data);
  }
};

// 处理调用回调函数，无论它是函数还是字符串键引用的函数
// Handles invoking the callback, whether it's a function or a string key referencing a function on the window object
function handleCallback(
  callback: string | ((result: any) => void),
  result: string
) {
  if (typeof callback === "function") {
    callback(result);
  } else if (typeof callback === "string") {
    // 执行运行时检查以确保我们只在其为函数时调用
    // Performs a runtime check to ensure we only call if it's a function
    const callbackFunction: Function | undefined = (window as any)[
      callback
    ] as unknown as Function | undefined;
    if (callbackFunction) {
      callbackFunction(result);
    }
  }
}

// 为iOS准备回调函数并更新location.href来触发桥接
// Prepares the callback for iOS and updates the location.href to trigger the bridge
function handleIOSCallback(data: H5EventData) {
  const callback = data.callback;

  if (typeof callback === "function") {
    const callbackName = `_CallBack_${_H5Event_Num++}`;
    (window as any)[callbackName] = (result: any) => {
      callback(result);
      delete (window as any)[callbackName];
    };
    data.callback = callbackName;
  }

  // 编码构造的数据以处理URL中的特殊字符
  // Encoding the constructed data to handle special characters in URLs
  window.location.href = `https://__bridge_loaded__?data=${encodeURIComponent(
    JSON.stringify(data)
  )}`;
}
